import { useIconColors } from './use-icon-colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SankeyChartIcon = ({
  size = 25
}) => {
  const colors = useIconColors();
  if (!colors) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    aqua,
    orange,
    purple
  } = colors;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("title", {
        children: "Sankey"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.3839 5C17.6998 5 18.8373 10.3787 21.1532 10.3787L21.1485 18.5339L21.1532 23.75C18.8373 23.75 17.6998 18.2528 15.3839 18.2528V5Z",
        fill: aqua,
        fillOpacity: "0.598623"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.84547 0C6.54729 0 7.87441 4.70588 10.5762 4.70588L10.5708 13.985L10.5762 20C7.87441 20 6.54729 13.6945 3.84547 13.6945V0Z",
        fill: orange,
        fillOpacity: "0.734746"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.80769",
        height: "25",
        fill: orange
      }), /*#__PURE__*/_jsx("rect", {
        x: "10.5756",
        y: "5.00012",
        width: "4.80769",
        height: "20",
        fill: aqua
      }), /*#__PURE__*/_jsx("rect", {
        x: "20.1924",
        y: "9.99988",
        width: "4.80769",
        height: "15",
        fill: purple
      })]
    })
  });
};
export default SankeyChartIcon;